import { defineMessages } from 'react-intl';

export default defineMessages({
  failureUpdateVideo: {
    id: 'app.containers.Video.UpdateRequest.Failure',
    defaultMessage: 'Erro ao salvar o link do vídeo!',
  },
  successUpdateVideo: {
    id: 'app.containers.Video.UpdateRequest.Success',
    defaultMessage: 'Link do vídeo salvo com sucesso!',
  },
  failureDeleteVideoLink: {
    id: 'app.containers.Video.DeleteRequest.Failure',
    defaultMessage: 'Erro ao deletar o video!',
  },
  successDeleteVideoLink: {
    id: 'app.containers.Video.DeleteRequest.Success',
    defaultMessage: 'Video deletado com sucesso!',
  },
  failureFetchVideoLink: {
    id: 'app.containers.Video.FetchRequest.Failure',
    defaultMessage: 'Erro ao buscar o vídeo dessa propriedade!',
  },
  errorFetchingLinksTitle: {
    id: 'app.containers.Video.errorFetchingLinks',
    defaultMessage: 'Erro ao buscar vídeo',
  },
  errorFetchingLinksDescription: {
    id: 'app.containers.Video.errorFetchingLinksDescription',
    defaultMessage: 'Um erro ocorreu ao buscar os links do vídeo. Tente novamente mais tarde.',
  },
});
